import { Currency } from '../../../../common/scripts/Account';
import DataType from './Config/DataStructure';
import IUserData from './DataObject/IUserData';

export default class UserData implements IUserData {
    readonly balance: number;
    readonly token: string;
    readonly account: string;
    readonly accountInfoUrl: string;
    readonly nickname: string;
    readonly avatar: string;
    readonly currency: Currency;
    readonly playerAccount: string;

    constructor(rawData: DataType.User.ResponseData) {
        this.balance = rawData.Balance;
        // this.token = rawData.AccessToken;
        // this.account = rawData.Account;
        // this.accountInfoUrl = rawData.AccountInfoURL ?? '';
        this.nickname = rawData.Nickname;
        this.avatar = rawData.Avatar;
        // this.currency = rawData.Currency as Currency;
        // this.playerAccount = rawData.PlayerAccount;
    }
}
